module.exports = __webpack_public_path__ + "static/media/gaming15.c7f20a8a.webp";